module.exports = __webpack_public_path__ + "static/media/githublogo.28e023f4.png";